<template>
  <div v-if="props.open">
    <div
      class="fixed inset-0 z-50  bg-university-primary opacity-50 sm:block"
    />
    <div
      class="fixed inset-0 z-50 py-6 overflow-auto bg-transparent sm:p-6 sm:p-12"
      @click.self="selfClose"
    >
      <div
        class="max-w-4xl mx-auto bg-white sm:rounded-lg sm:shadow z-20 relative"
        data-testid="modal-content"
      >
        <div
          id="modal-title"
          class="bg-teal-accent w-full h-50p flex py-3.5 px-5 align-center"
          :class="props.title ? 'justify-between' : 'justify-end'"
        >
          <h2
            v-if="props.title"
            class="text-indigo-base text-normal leading-tight font-bold font-montserrat uppercase"
          >
            {{ props.title }}
          </h2>
          <div v-if="props.showCloseButton">
            <button
              class="block h-6 w-6 flex items-center justify-center"
              data-testid="close-modal-button"
              @click="close()"
            >
              <span class="sr-only">Close</span>
              <svg
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#007F80"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
        <slot name="modalHeader">
          <div class="flex flex-col items-center justify-end">
            <img
              v-if="props.showLogo"
              class="w-48 object-contain h-10 mt-10"
              :src="logo"
            />
          </div>
        </slot>
        <slot name="modal-content" />
        <div :class="props.footerClass ? props.footerClass : 'mt-6'">
          <slot name="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from "vue";
defineOptions({
  name: "BaseModal"
});

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: ""
  },
  showCloseButton:{
    type: Boolean,
    default: true
  },
  closeOnOutsideClick: {
    type: Boolean,
    default: true
  },
  showLogo: {
    type:Boolean,
    default: true
  },
  footerClass: {
    type: String,
    default: ""
  }
});

const emit = defineEmits(['closeModal']);

const logo = `${import.meta.env.VITE_CDN_ENDPOINT}/images/api-connect-logo.png`;

const close = () =>  emit("closeModal");

const selfClose = () => {
  if (props.closeOnOutsideClick) emit('closeModal');
};
</script>
